<template>
  <div><NewParamaBundleComponent></NewParamaBundleComponent></div>
</template>

<script>
import NewParamaBundleComponent from "../../components/Courses/NewParamaBundle/NewParamaBundle.component.vue";
export default {
  components:{
    NewParamaBundleComponent
  }
};
</script>

<style></style>
